import { createSlice } from "@reduxjs/toolkit";

import type { FlagRead } from "@/types/api/types";
const initialState: FlagRead[] = [];

export const flagsSlice = createSlice({
  name: "flags",
  initialState,
  reducers: {
    setFlags: (state, action) => {
       
      return action.payload;
    },
  },
});

export const { setFlags } = flagsSlice.actions;

export default flagsSlice.reducer;
